import React, { useEffect, useState, useCallback } from 'react';
import CButton from '../../components/button/button';
import CChip from '../../components/chip/chip';
import CInput from '../../components/input/input';
import { Space } from '../../components/utils/utils';
import {
  addLitigiu,
  deleteLitigiu,
  downloadRaport,
  getLitigii,
  importLitigations
} from '../../network/litigii';
import { notify } from '../../notifications/notification';
import { variables } from '../../utils/variables';
import styles from './litigii.module.scss';
import { menuEntries, LITIGII_TABS } from '../../types/menu-litigii';
import Tabs from '../../components/vertical-tab/tabs';
import {
  downloadOneDecision,
  getPrincipalsNotifications
} from '../../network/notifications';
import { Pagination, Skeleton } from 'antd';
import CCard from '../../components/card/card';
import {
  computeDescriptionMessage,
  mapDetails,
  mapTypeToMessage
} from '../../utils/notifications';
import { prettyDate } from '../../utils/strings';
import { TYPES_NOTIFICATIONS } from '../../types/menu-notifications';
import { useHistory } from 'react-router';
import { ROUTES } from '../../routing/routes';
import { IoCloudDownload } from 'react-icons/io5';
import CTable from '../../components/table/table';
import { columnsLitigations } from '../../utils/tables';
import { ILitigation } from '../../utils/interfaces/interfaces';
import CModal from '../../components/modal/modal';
import EditObservations from '../../components/forms/edit_observations';
import EditPriority from '../../components/forms/edit_priority';
import { IEditField, Priorities } from '../../types/litigations';
import EditLitigationField from '../../components/forms/edit_litigation_field';
import EditLitigationDocument from '../../components/forms/edit_litigation_document';
import CLitigationTimeline from '../../components/timeline/litigationTimeline';
import CSearchBar from '../../components/search-bar/search_bar';
import CUpload from '../../components/input/upload';
import {
  checkFilesHaveSameType,
  combineFiles,
  handleFileChange,
  initialFile
} from '../../utils/files';
import { typesFiles } from '../../types/uploaded-data';
import CArchive from '../../components/archive/archive';
import EditLitigationArchiveDocument from '../../components/forms/edit_litigation_archive_document';
import EditLitigationPermissionsModal from '../../components/forms/edit_litigation_permissions';

const Litigii = () => {
  const [litigii, setLitigii] = useState([]);
  const [litigiiData, setLitigiiData] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [uniqueNumber, setUniqueNumber] = useState('');
  const [currOption, setOption] = useState(menuEntries[0]);
  const [notifications, setNotifications] = useState([]);
  const [currentPage, setPage] = useState(1);
  const [info, setInfo] = useState({
    totalRecords: 0
  });
  const [editField, setEditField] = useState<IEditField | undefined>();
  const [editFieldModal, openEditLitigationField] = useState(false);
  const [priorityModal, openPriority] = useState(false);
  const [document, setDocument] = useState(initialFile);

  const [litigation, setLitigation] = useState<ILitigation | undefined>(
    undefined
  );
  const [documentsModal, openDocuments] = useState(false);
  const [editDocumentModal, setEditDocumentModal] = useState(false);
  const [editArchiveModal, setEditArchiveModal] = useState(false);
  const [permissionsModal, setPermissionsModal] = useState(false);

  const [filterValue, setValue] = useState('');
  const [sort, setSort] = useState('');
  const [sortDirection, setSortDirection] = useState('');
  const [pagination, setPagination] = useState<any>();
  const [archiveModal, openArchive] = useState(false);

  const handleFilter = (event: React.ChangeEvent<any>) => {
    const { value } = event.target;
    setValue(value);
  };

  const handleArchives = async (litigation: ILitigation) => {
    setLitigation(litigation);
    // await getDocuments(litigation);
    openArchive(true);
  };

  const handleDocuments = async (litigation: ILitigation) => {
    setLitigation(litigation);
    // await getDocuments(litigation);
    openDocuments(true);
  };

  const handleFile = (
    event: React.ChangeEvent<HTMLInputElement>,
    setFile: any
  ) => {
    if (event.target.files && event.target.files.length > 0) {
      console.log(event.target.files);
      if (!checkFilesHaveSameType(event.target.files, typesFiles.csv)) {
        if (
          !checkFilesHaveSameType(event.target.files, typesFiles.csvFirefox)
        ) {
          notify('Trebuie sa incarcati documente de tip CSV', 'info');
          return;
        }
      }
    }
    handleFileChange(event, setFile);
  };

  const getLitigiiList = (filter?: any) => {
    // setLoading(true);
    getLitigii(pagination?.current ?? 1, filterValue, sort, sortDirection).then(
      ({ data }) => {
        setLitigii(data.data);
        setLitigiiData(data);
        // setLoading(false);
      }
    );
  };

  useEffect(() => {
    console.log(pagination);
    getLitigiiList();
  }, [filterValue, sort, sortDirection, pagination]);

  useEffect(() => {
    getLitigiiList();
  }, []);

  const importCsv = async () => {
    importLitigations(document[0]).then(() => {
      notify('Ati importat litigiile cu success', 'success');
      getLitigiiList();
    });
  };

  const submitUniqueNumber = (event: React.MouseEvent) => {
    event.preventDefault();

    if (uniqueNumber && uniqueNumber.length > 0) {
      addLitigiu(uniqueNumber)
        .then(() => {
          getLitigiiList();
          setUniqueNumber('');
          notify('Dosarul a fost adăugat cu succes.', 'success');
        })
        .catch(() => {
          notify('Dosarul exista deja in lista', 'error');
        });
    } else {
      notify('Numărul nu este unul valid.', 'warning');
    }
  };

  const deleteFile = (id: number) => {
    deleteLitigiu(id).then(() => {
      getLitigiiList();
      notify('Dosarul a fost șters cu succes.', 'success');
    });
  };

  const handleViewDetails = (litigation: any) => {
    history.push(ROUTES.LITIGII + '/' + encodeURIComponent(litigation.id));
    window.scrollTo(0, 0);
  };

  const handleEditField = (field: IEditField) => {
    setEditField(field);
    openEditLitigationField(true);
  };

  const getNotifications = useCallback(() => {
    if (currOption.key === LITIGII_TABS.NOTIFICARI) {
      // setLoading(true);
      getPrincipalsNotifications(currOption.key, currentPage).then(data => {
        setNotifications(data.data);
        setInfo(data.data);
        // setLoading(false);
      });
    }
  }, [currentPage, currOption]);

  /* watcher for tabs  */
  useEffect(() => {
    getNotifications();
  }, [currOption, getNotifications]);
  const history = useHistory();

  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    setSort(sorter?.column?.dataIndex);
    setSortDirection(sorter?.order);
    setPagination(pagination);
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {!loading && (
          <div className={styles.rowInfo}>
            <div className='column align-start fullWidth'>
              <p className='subheading-dark bold'>Gestionare litigii</p>
            </div>
          </div>
        )}
        {!loading && (
          <>
            <div className={styles.row}>
              <CInput
                placeholder='Număr dosar unic'
                label=''
                id='number'
                type='text'
                name='number'
                value={uniqueNumber}
                onChange={e => setUniqueNumber(e.target.value)}
              />
              <Space horizontal='30px' />
              <CButton
                type='submit'
                label='Adaugă'
                onClick={submitUniqueNumber}
              />
              <Space horizontal='40px' /> sau <Space horizontal='40px' />
              <CUpload
                endingStyle={{ top: 'auto' }}
                title='Încărcați documentul'
                label=''
                id='document'
                name=''
                value={document}
                onChange={e => handleFile(e, setDocument)}
              />
              <Space horizontal='30px' />
              <CButton type='submit' label='Importa' onClick={importCsv} />
            </div>

            <Space vertical={variables.verticalSpace} />
            <p className='subheading-dark bold'>Dosarele adăugate</p>
            <CSearchBar value={filterValue} onChange={handleFilter} />
          </>
        )}
        {!loading && (
          <div className={styles.table}>
            <CButton
              type='button'
              onClick={downloadRaport}
              label={<IoCloudDownload />}
              className={styles.download}
            />
            <CTable
              // rowClassName={(record: ILitigation) =>
              //   record.priority === Priorities.High
              //     ? styles.highPriority
              //     : undefined
              // }
              pageSize={variables.litigationsPaginationRatio}
              rowClassName={styles.tableRow}
              total={litigiiData && litigiiData.totalRecords}
              data={
                litigii &&
                (litigii as ILitigation[]).map((el: ILitigation) => ({
                  ...el,
                  key: el.id
                }))
              }
              columns={columnsLitigations(
                styles,
                openPriority,
                handleEditField,
                handleDocuments,
                handleArchives,
                handleViewDetails,
                setLitigation,
                setEditDocumentModal,
                setEditArchiveModal,
                setPermissionsModal,
                deleteFile
              )}
              onChange={handleTableChange}
            />
          </div>
        )}
        {litigation && (
          <CModal opened={documentsModal} openModal={openDocuments}>
            {loading ? (
              <Skeleton active />
            ) : (
              <CLitigationTimeline documents={litigation.documents} />
            )}
          </CModal>
        )}
        {litigation && (
          <CModal opened={archiveModal} openModal={openArchive}>
            {loading ? (
              <Skeleton active />
            ) : (
              <CArchive documents={litigation.archiveDocuments} />
            )}
          </CModal>
        )}

        {litigation && editField && (
          <CModal opened={editFieldModal} openModal={openEditLitigationField}>
            <EditLitigationField
              readOnly={
                editField.key === 'court' ||
                editField.key === 'solution' ||
                editField.key === 'object' ||
                editField.key === 'parties'
              }
              litigation={litigation}
              field={editField.key}
              originalValue={editField.originalValue}
              label={editField.label}
              callback={() => {
                getLitigiiList();
                openEditLitigationField(false);
              }}
            />
          </CModal>
        )}
        {litigation && (
          <CModal opened={priorityModal} openModal={openPriority}>
            <EditPriority
              readOnly={false}
              litigation={litigation}
              callback={priority => {
                getLitigiiList();
                openPriority(false);
              }}
            />
          </CModal>
        )}
        {litigation && (
          <CModal opened={editDocumentModal} openModal={setEditDocumentModal}>
            <EditLitigationDocument
              litigation={litigation}
              callback={() => {
                getLitigiiList();
                setEditDocumentModal(false);
              }}
            />
          </CModal>
        )}
        {litigation && (
          <CModal opened={editArchiveModal} openModal={setEditArchiveModal}>
            <EditLitigationArchiveDocument
              litigation={litigation}
              callback={() => {
                getLitigiiList();
                setEditArchiveModal(false);
              }}
            />
          </CModal>
        )}
        {litigation && (
          <CModal opened={permissionsModal} openModal={setPermissionsModal}>
            <EditLitigationPermissionsModal litigation={litigation} />
          </CModal>
        )}
        {!loading && (
          <div className={styles.list}>
            {litigii && litigii.length === 0 && (
              <p className='body-dark'>
                Momentan nu aveți niciun dosar adăugat.
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Litigii;
